module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/worker/worker-registration/worker-registration.component.scss
// module id = ./src/app/worker/worker-registration/worker-registration.component.scss
// module chunks = main